import { useSlotLabel } from "../hooks/useSlotLabels";

export default function RestraintPalletsHeadingSlot() {
  const lbl = useSlotLabel("restraint.pallets-heading");
  return (
    <div className="pt-3 border-t">
      <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">
        {lbl("title", "Pallets")}{" "}
        <span className="font-normal lowercase text-slate-400">
          — {lbl("subtitle", "FLD confirms these on QA")}
        </span>
      </h4>
    </div>
  );
}
